import { ROUTES } from './routes';

// Helper function to get the base pattern of a route function
const getRoutePattern = (routeFn: Function) => {
  // Call the function with a placeholder to get the pattern
  const pattern = routeFn('*');
  // Replace the placeholder with a wildcard
  return pattern.replace('*', '*');
};

export const PUBLIC_ROUTES = [
  ROUTES.SIGN_IN,
  ROUTES.SIGN_UP,
  ROUTES.SIGN_UP_SUCCESS,
  ROUTES.VERIFY_EMAIL,
  ROUTES.UNAUTHORIZED,
  ROUTES.DESIGN_SYSTEM_SIGN_IN,
  getRoutePattern(ROUTES.MH_RISK_ASSESSMENT_SURVEY),
  getRoutePattern(ROUTES.QR_REDIRECT),
  getRoutePattern(ROUTES.EXTERNAL_FIRST_AID),
  getRoutePattern(ROUTES.INSTRUCTION_PUBLIC),
] as const;
